import * as React from 'react';
import {connect} from "react-redux";
import {Position} from "../../models/Position";
import {ApplicationState} from "../../store";
import {PositionList}  from "../components/PositionList ";
import {ColumnData} from '../../models/ColumnData';
import {TabsService} from '../TabsService';
import {Tab, TabTypes} from '../Tab';
import {actionPositionFetchAll, actionPositionDelete, actionDeletePositions} from '../../store/positions/actions'
import {Button} from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {t} from "../../core/localization";
import {Role} from "../../models/Role";
import {Department} from "../../models/Department";
import {actionDepartmentsFetchAll} from "../../store/departments";

export interface PositionsTabProps {
	positions: Position[]
	departments: Department[]
	tab: Tab
}

export interface PositionsTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		positions: state.positions.list,
		departments: state.departments.list,
		tab: state.tabs.active
	};
}

class PositionsTab extends React.Component<PositionsTabProps, PositionsTabState> {

	constructor(props: PositionsTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: PositionsTabProps) {
	}

	componentDidMount() {
		actionPositionFetchAll()
		actionDepartmentsFetchAll()
	}

	onOpenClick(position: Position){
		TabsService.createTab(t.Position + ' ' + position.title, TabTypes.POSITIONS_NEW, position)
	}

	onCopyClick(position: Position){
		TabsService.createTab(t.Position + ' ' + position.title, TabTypes.POSITIONS_NEW, { ...position, id: null })
	}

	onDeleteClick(position: Position){
		actionPositionDelete(position);
	}

	onActionDeleteClick(positions: Position[]){
		actionDeletePositions(positions);
	}

	render(): React.ReactNode {

		const {positions} = this.props;

		var departmentsMap = this.props.departments.reduce((map: any, department: Department) => {
			map[department.id] = department.title;
			return map;
		}, {});

		const columns = [
			new ColumnData(t.Name, "title" ),
			new ColumnData(t.Description, "description" ),
			new ColumnData(t.Department, "departmentId", departmentsMap )
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewPosition}</Button></div>
				<PositionList
					columns={columns}
					items={positions}
					title={t.Position}
					onOpenClick={(position: Position) => this.onOpenClick(position)}
					onCopyClick={(position: Position) => this.onCopyClick(position)}
					onDeleteClick={(position: Position) => this.onDeleteClick(position)}
					onActionDeleteClick={(positions: Position[]) => this.onActionDeleteClick(positions)}
					tab={this.props.tab}
				/>
			</div>
		);
	}

	onNewClick() {
		TabsService.createTab(t.NewPosition, TabTypes.POSITIONS_NEW, new Position())
	}
}

export default connect(mapStateToProps)(PositionsTab);
